import { render } from "./UserQuery.vue?vue&type=template&id=24fd0f8c&scoped=true"
import script from "./UserQuery.vue?vue&type=script&lang=js"
export * from "./UserQuery.vue?vue&type=script&lang=js"

import "./UserQuery.vue?vue&type=style&index=0&id=24fd0f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fd0f8c"]])

export default __exports__